export type TomEncerramento = 'neutro' | 'marca' | 'atencao' | 'erro' | 'sucesso';

interface ClassesTom {
  readonly caixa: string;
  readonly texto: string;
  readonly icone: string;
}

const CLASSES: Record<TomEncerramento, ClassesTom> = {
  neutro: {
    caixa: 'border-solid bg-neutral-50 border-neutral-200',
    texto: 'text-neutral-700',
    icone: 'bg-neutral-100 text-neutral-700',
  },
  marca: {
    caixa: 'border-solid bg-brand-50 border-brand-200',
    texto: 'text-brand-700',
    icone: 'bg-brand-50 text-brand-600',
  },
  atencao: {
    caixa: 'border-solid bg-warning-50 border-warning-200',
    texto: 'text-warning-700',
    icone: 'bg-warning-50 text-warning-700',
  },
  erro: {
    caixa: 'border-solid bg-error-50 border-error-200',
    texto: 'text-error-700',
    icone: 'bg-error-50 text-error-700',
  },
  sucesso: {
    caixa: 'border-solid bg-success-50 border-success-200',
    texto: 'text-success-700',
    icone: 'bg-success-50 text-success-700',
  },
};

export function classesDoTom(tom: TomEncerramento): ClassesTom {
  return CLASSES[tom];
}
